import { useEffect, useState } from "react";
import "./Home.scss";
import Hero from "../Home/Hero/Hero";
import Subscription from "../Home/Subscription/Subscription";
import Opinions from "../Home/Opinions/Opinions";
import About from "../Home/About/About";
import api from "../../utils/api";
import OurServices from "./OurServices/OurServices";
import { useAuth } from "../../context/AuthContext";
import UserSubscriptions from "../UserSubscriptions/UserSubscriptions";
import DownloadApp from "./DownloadApp/DownloadApp";

const Home = () => {
  const { updateSocialLinks, updateSingleBooking, user } = useAuth();
  const [categories, setCategories] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the combined API endpoint
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await api.get("/users/active-items");
        // Extract data from the response
        const { categories, socialLinks, normalBookingAvailability } =
          response.data.data;

        setCategories(categories.items);

        updateSingleBooking(normalBookingAvailability); // This sets the correct value
        // handleSingleBookingChange(false); // REMOVED: This was overwriting the value above
        updateSocialLinks(socialLinks);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchRatings = async () => {
      try {
        const response = await api.get(`/ratings`);

        if (response.data.status === "success") {
          setRatings(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching ratings:", error);
      }
    };

    fetchData();
    fetchRatings();
  }, []);

  // Example function to update singleBooking (you can call this wherever needed)

  return (
    <div>
      <div id="home">
        <Hero />
      </div>
      <div id="services">
        <OurServices categories={categories} loading={loading} />
      </div>

      {user?.isSubscriper ? (
        <UserSubscriptions />
      ) : (
        <div id="subscription">
          <Subscription loading={loading} />
        </div>
      )}

      {ratings.length > 0 && (
        <div id="opinions">
          <Opinions ratings={ratings} />
        </div>
      )}

      <div id="download">
        <DownloadApp />
      </div>

      <div id="about">
        <About />
      </div>
    </div>
  );
};

export default Home;
